'use strict'

import Axios from 'axios';
import { parseResponse, handleError } from '@/_helpers/utils.js';

export default {
  storeOne({ email, password, captcha_token }) {
    return Axios.post('/1.0/access-tokens', { users: [{ email, password }], captcha_token })
      .then(response => {
        return parseResponse(response).data[0];
      })
      .catch(err => {
        return Promise.reject(handleError(err));
      });
  },

  removeOne({ token }) {
    return new Promise((resolve, reject) => {
      Axios.delete('/1.0/access-tokens', { data: { access_tokens: [{ token: token }] } })
        .then(() => {
          resolve();
        })
        .catch(err => reject(handleError(err)));
    });
  },

  fetchOnePasswordRecovery (token) {
    return Axios.get('/1.0/access-tokens/password-recovery', {headers: { Authorization: `Bearer ${token}` }})
      .then(response => {
        return parseResponse(response).data[0]
      })
      .catch(err => {
        return Promise.reject(handleError(err))
      })
  },

  fetchOneAuthorization (token) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/access-tokens/authorization')
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  storeOnePasswordRecovery ({email}) {
    return Axios.post('/1.0/access-tokens/password-recovery', {users: [{email}]})
      .then(response => {
        return parseResponse(response).data[0];
      })
      .catch(err => {
        return Promise.reject(handleError(err))
      })
  },

  updateUserPassword (password) {
    return new Promise((resolve, reject) => {
      Axios.put('/1.0/user-passwords', {users: [{password}]})
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)))
    })
  }
}
